import { render, staticRenderFns } from "./TestoDecalogoSicurezza.vue?vue&type=template&id=54619ecd&scoped=true"
var script = {}
import style0 from "./TestoDecalogoSicurezza.vue?vue&type=style&index=0&id=54619ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54619ecd",
  null
  
)

export default component.exports